import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';

import store from '../../store';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';
import {staggeredReveal} from '../../css/styleSets';

@customElement('assistant-list-select-item')
export class AssistantListSelectItem extends connect(store)(LitElement) {

	@property({type: Object})
	option = {};

	@property({type: String})
	selected = '';

	@property({type: String})
	action = '';

	@property({type: Boolean})
	canBeSelected = true;

	@property({type: Boolean})
	hideDisabled = false;

	static styles = [
		staggeredReveal,
		css`
			:host {
			}

			.item {
				background: var(--color-widget-background);
				color: var(--color-widget-text);
				display: flex;
				flex-direction: column;
				gap: 10px;
				padding: 16px;
				cursor: pointer;
				transition: background-color 0.4s ease-out, color 0.4s ease-out;
			}

			.item.selected {
				background: var(--color-widget-background-selected-dark);
			}

			.item:hover {
				background: var(--color-widget-background-hover);
			}

			.item.selected:hover {
				background: var(--color-widget-background-selected-dark);
			}

			.label {
				font: var(--font-widget-big-label);
				color: var(--color-widget-text);
				display: flex;
				flex-direction: row;
				position: relative;
				justify-content: space-between;
			}

			.labeltext {

			}

			.icon {

			}

			.description {
				font: var(--font-widget-info);
				color: var(--color-widget-info);
				line-height: 1.4;
				opacity: 0;
				animation: reveal 0.25s ease-out 0s 1 normal forwards;
			}

			@keyframes reveal {
				from {
					opacity: 0;
				}

				to {
					opacity: 100%;
				}
			}

			.selected button {
				color: var(--color-text-widget-active);
				border: var(--border-widget-active);
				background-color: var(--color-background-widget-active);
			}

			.fixed button {
				border: var(--border-widget-fixed);
				pointer-events: none;
			}

			.disabled {
				color: var(--color-grey6);
				pointer-events: none;
			}

			.disabled .label {
				color: var(--color-grey6);
			}

			.disabled .icon {
				opacity: 0.5;
			}

			.disabled.hideDisabled {
				display: none
			}

			.icon {
				display: inline-block;
			}

			.icon svg {
				display: block;
			}
		`];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
	}

	isSelected() {
		return this.selected === this.option.id;
	}

	isExcluded() {
		return false;
	}

	isDisabeled() {
		return !this.canBeSelected;
	}

	canBeExcluded() {
		return true;
	}

	async setOption() {
		if (this.action) {
			store.dispatch(
				{
					type: this.action,
					payload: {
						id: this.option.id
					}
				}
			);
		}
	}

	render() {
		return html`
			<div class="item ${classMap({
				selected: this.isSelected(),
				disabled: this.isDisabeled(),
				hideDisabled: this.hideDisabled,
				fixed: !this.canBeExcluded()
			})}" @click="${this.setOption}">
				<div class="label">
					<div class="labeltext">${this.option.label[this.lang]}</div>
					${when(
						this.isSelected(),
						() => html`
							<div class="icon">${radioChecked}</div>`,
						() => html`
							<div class="icon">${radio}</div>`,)
					}
				</div>
				${when(this.option.description !== null && this.option.description[this.lang] && this.option.description[this.lang] !== '' && this.option.description[this.lang] !== null && this.isSelected(), () => html`
					<div class="description">
						${this.option.description[this.lang]}
					</div>
				`)}

			</div>
		`;
	}
}
